import { GroupBase, StylesConfig } from 'react-select'
import styled from 'styled-components'
import { DropdownVariantE, IDropdownOption, IDropdownProps, IDropdownVariantSizeE } from 'primsell-shared-layer/types'
import { baseTheme, themePrimsell } from 'primsell-shared-layer/styles/theme'

export const StyledDropdownWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const commonDropdownStyles = <
  Option extends IDropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props?: Pick<IDropdownProps, 'error' | 'isDisabled' | 'dropdownVariantSize' | 'variant' | 'menuMinWidth'>
): StylesConfig<Option, IsMulti, Group> => ({
  control: (base) => ({
    ...base,
    width: '100%',
    height: '40px',
    borderRadius: '8px',
    border:
      props?.variant === DropdownVariantE.SECONDARY
        ? 'none'
        : `1px solid ${props?.error ? themePrimsell.border.error : themePrimsell.border.default}`,
    backgroundColor: props?.variant === DropdownVariantE.SECONDARY ? 'transparent' : `${baseTheme.colors.greySoft}`,

    cursor: 'pointer',
    fontFamily: 'Inter, sans-serif',
    boxShadow: 'none',
    '&:hover': {
      borderColor: props?.error ? themePrimsell.border.error : themePrimsell.border.hover,
    },
    '&:active': {
      borderColor: props?.error ? themePrimsell.border.error : themePrimsell.border.focus,
    },
    '&:focus-within': {
      borderColor: props?.error ? themePrimsell.border.error : themePrimsell.border.focus,
    },
    transition: 'border-color 0.3s',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: `${props?.isDisabled ? '#9a9b9c' : baseTheme.colors.lightDark}`,
    fontSize: '14px',
    lineHeight: '20px',
  }),
  menu: (provided) => ({
    ...provided,
    padding: `${props?.dropdownVariantSize === IDropdownVariantSizeE.DEFAULT ? '10px 8px' : '6px 8px'}`,
    backgroundColor: baseTheme.colors.greySoft,
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontFamily: 'Inter, sans-serif',
    boxShadow: 'none',
    maxHeight: '292px',
    overflowY: 'auto',
    zIndex: 2,
    minWidth: `${props?.menuMinWidth ? props?.menuMinWidth : ''}`,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '172px',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    padding: '0px',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: 'nowrap',
    padding: `${props?.variant === DropdownVariantE.PRIMARY ? base.padding : '0'}`,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '0px',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: !state.isSelected ? '#8c8c8c1a' : '#743bbc1a',
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: '14px',
  }),
})
